<script>
import { mapGetters, mapMutations } from 'vuex';
import stepsMixin from '@/mixins/stepsMixin'
export default {
	mixins: [stepsMixin],
	props: ['client'],
	components: {
		SvgIcon: () => import('@/components/SvgIcon'),
	},
	data() {
		return {
			name: 'analisis_riesgo_del_negocio',
			form: {
				descripcionCartera: '',
				descripcionActividad: '',
				alcanceGeografico: '',
				cuotaMercado: '',
				nivelExporacionesVentas: '',
				nivelImportacionesCompras: '',
				comentariosCuotaMercado: '',
				multipleGeografia: '',
				comentariosMultipleGeografia: '',
				multipleActividadEconomica: '',
				comentariosMultipleActividadEconomica: '',
				numeroProductosServicios: '',
				vulnerabilidadTipoCambio: '',
				comentariosNumeroProductosServicios: '',
				comentariosVulnerabilidadTipoCambio: '',
				// empresaAcreditada: '',
				concentracionClientes: '',
				concentacionProveedores: '',

			},

			geografiasForm: [
				{
					nombre: '',
					query: '',
					ano: '',
					porcentaje: ''
				}
			],
			geografias: [],
			actividadesForm: [
				{
					nombre: '',
					query: '',
					ano: '',
					porcentaje: ''
				}
			],
			actividades: [],
			principalesClientesForm: [
				{
					nombre: '',
					ano: '',
					participacion: ''
				}
			],
			principalesClientes: [],

			chart: {
				series: [44, 55, 41],
				chartOptions: {
					labels: ['Mexico', 'España', 'Panama'],
					colors: ['#1973B8', '#D8BE75', '#2DCCCD'],
					chart: {
						type: 'donut',
					},
					responsive: [{
						options: {
							pie: {
								donut: {
									size: '20%'
								}
							},
							chart: {
								width: 120
							},
							legend: {
								position: 'bottom'
							}
						}
					}]
				},
			}
		}
	},

	computed: {
		showGeo() {
			let data = this.geografias.filter(sh => {
				return sh.nombre && sh.porcentaje
			})
			return data
		},

		showActivities() {
			let data = this.actividades.filter(sh => {
				return sh.nombre && sh.porcentaje
			})
			return data
		},
		showPrincipalesClientes() {
			let data = this.principalesClientes.filter(sh => {
				return sh.nombre && sh.participacion
			})
			return data
		}
	},

	watch: {
		// 'client.shareholders': {
		// 	handler(nVal) {
		// 		if(nVal.length) {
		// 			this.$set(this.shareholders, [...nVal])
		// 		}
		// 	}
		// }
		'client': {
			handler(nVal) {
				this.fillForm()
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		calcFill() {
			let fields = Object.keys(this.form)
			if(this.form.multipleGeografia == 'NO') {
				let index = fields.indexOf('comentariosMultipleGeografia')
				fields.splice(index, 1)
			}
			if(this.form.multipleActividadEconomica == 'NO') {
				let index = fields.indexOf('comentariosMultipleActividadEconomica')
				fields.splice(index, 1)
			}
			let points = 100 / fields.length

			let fill = 0

			fields.forEach(f => {
				if(this.form[f]) {
					fill += points
				}
			})

			return Math.round(fill)
		},

		fillForm() {
			let data = {}
			if(this.client.arce.hasOwnProperty(this.name)) {
				data = {...this.client.arce[this.name]}
			}
			if(!Object.keys(data).length) {
				this.$set(this, 'form', {
					descripcionCartera: '',
					descripcionActividad: '',
					alcanceGeografico: '',
					cuotaMercado: '',
					nivelExporacionesVentas: '',
					nivelImportacionesCompras: '',
					comentariosCuotaMercado: '',
					multipleGeografia: '',
					comentariosMultipleGeografia: '',
					multipleActividadEconomica: '',
					comentariosMultipleActividadEconomica: '',
					numeroProductosServicios: '',
					vulnerabilidadTipoCambio: '',
					comentariosNumeroProductosServicios: '',
					comentariosVulnerabilidadTipoCambio: '',
					// empresaAcreditada: '',
					concentracionClientes: '',
					concentacionProveedores: '',	
				})
				this.$set(this, 'geografias', [
					{
						nombre: '',
						query: '',
						ano: '',
						porcentaje: ''
					}
				])
				this.$set(this, 'actividades', [
					{
						nombre: '',
						query: '',
						ano: '',
						porcentaje: ''
					}
				])
				this.$set(this, 'principalesClientes', [
					{
						nombre: '',
						query: '',
						participacion: ''
					}
				])

				return 
			}
			this.$set(this, 'geografias', data.geografias || [...this.geografias])
			this.$set(this, 'actividades', data.actividades || [...this.actividades])
			this.$set(this, 'principalesClientes', data.principalesClientes || [...this.principalesClientes])

			delete data['geografias']
			delete data['actividades']
			delete data['principalesClientes']
			this.$set(this, 'form', data)
		},
		save() {
			let vm = this
			let payload =  {
				client:  this.client,
				form: this.name,
				data: Object.assign({...this.form}, {
					geografias: [...this.geografias], 
					actividades: [...this.actividades], 
					principalesClientes: [...this.principalesClientes]
				}),
				fill: vm.calcFill()
			}
			vm._setDataChild(payload)
			vm.$emit('updateArce')
		},
		getAnosList(data) {
			let list = []
			data.forEach(element => {
				if(!list.includes(element.ano)) {
					list.push(element.ano)
				}
			});
			return list
		},
		showGeografias() {
			this.$set(this, 'geografiasForm', [...this.geografias.map(i => ({...i}))])
			this.showModal('#geografiasModal')
		},

		showActividades() {
			this.$set(this, 'actividadesForm', [...this.actividades.map(i => ({...i}))])
			this.showModal('#actividadesModal')
		},
		showClientes() {
			this.$set(this, 'principalesClientesForm', [...this.principalesClientes.map(i => ({...i}))])
			this.showModal('#clientesModal')
		},
		addNew() {
			this.geografiasForm.push(
				{
					nombre: '',
					porcentaje: '',
					ano: '',
					query: ''
				}
			)
		},
		addNewActivity() {
			this.actividadesForm.push(
				{
					nombre: '',
					porcentaje: '',
					ano: '',
					query: ''
				}
			)
		},
		addNewClient() {
			this.principalesClientesForm.push(
				{
					nombre: '',
					participacion: '',
					query: ''
				}
			)
		},
		deleteItem(index, items) {
			items.splice(index, 1)
		},
		deleteActivityItem(index) {
			this.actividadesForm.splice(index, 1)
		},
		showModal(id) {
			if(document.querySelectorAll(`${id}`).length > 1) {
				$(`body > ${id}`).remove()
				this.showModal(id)
			} else {
				$(id).appendTo("body").modal('show')

			}
		},

		saveAllGoe() {
			this.$set(this, 'geografias',  [...this.geografiasForm.map(i => ({...i}))])
			this.$notify({
				type: 'success',
				group: 'simulator',
				title: 'Success!',
				text: 'The record has been saved successfully'
			})
		},

		saveAllActivities() {
			this.$set(this, 'actividades', [...this.actividadesForm.map(i => ({...i}))])
			this.$notify({
				type: 'success',
				group: 'simulator',
				title: 'Success!',
				text: 'The record has been saved successfully'
			})
		},
		saveAllClientes() {
			this.$set(this, 'principalesClientes', [...this.principalesClientesForm.map(i => ({...i}))])
			this.$notify({
				type: 'success',
				group: 'simulator',
				title: 'Success!',
				text: 'The record has been saved successfully'
			})
		},
		closeModal() {
			this.hiddenSteps()
			this.fillForm()
		},
		...mapMutations({
			_setDataChild: 'arceDetails/setDataChild'
		})
		// ...mapMutations({
		// 	setShareholders: 'arceDetails/setShareholders'
		// })
	},
	mounted() {
		$('#formBusinnessriskModal').on('hide.bs.modal', this.closeModal)
	},

	beforeDestroy() {
		$('#formBusinnessriskModal').off('hide.bs.modal', this.closeModal)
	}
	
}
</script>
<template>
	<div style="">
		<div class="text-right py-2">
			<button class="s-btn s-btn--primary" @click="showModal('#formBusinnessriskModal')">
				Editar
			</button>
		</div>
		<div>
			<div class="s-collapse__header collapsed" data-toggle="collapse" data-target="#c_abr_n_1" aria-expanded="true" aria-controls="c_abr_n_1">
				<div class="d-flex">
					<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>Información General</span></h6>
				</div>
			</div>
			<div id="c_abr_n_1" class="collapse hide" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">
					<div class="col-12 py-3">
						<table class="s-table w-100 mx-auto">
							<thead>
								<tr>
									<th></th>
									<th>2019</th>
									<th>2018</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										Backlog (en miles y TC de lo EEFF)
									</td>
									<td class="text-center">
										0
									</td>
									<td class="text-center">
										0
									</td>
									<td class="text-right">
										<button class="s-btn s-btn--outline p-1">
											<svg-icon name="down" />
										</button>
									</td>
								</tr>
								<tr>
									<td>
										Backlog/Ventas
									</td>
									<td class="text-center">
										0%
									</td>
									<td class="text-center">
										0%
									</td>
									<td class="text-right">
										<button class="s-btn s-btn--outline p-1">
											<svg-icon name="down" />
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-3">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Descripción de la cartera</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.descripcionCartera">
						</label>
					</div>
				</div>
			</div>

			<div class="s-collapse__header   mt-2" data-toggle="collapse" data-target="#c_abr_n_2" aria-expanded="true" aria-controls="c_abr_n_2">
				<div class="d-flex">
					<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> ACTIVIDAD DEL CLIENTE</span></h6>
				</div>
			</div>
			<div id="c_abr_n_2" class="collapse show" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">

					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Descripción de la actividad del cliente</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.descripcionActividad">
						</label>
					</div>

					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Alcance Geográfico del Cliente</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.alcanceGeografico">
						</label>
					</div>
					
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Cuota de Mercado</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.cuotaMercado">
						</label>
					</div>
					
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Nivel de exportaciones sobre el total de sus ventas</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.nivelExporacionesVentas">
						</label>
					</div>
					
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Nivel de importaciones sobre el total de sus compras</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.nivelImportacionesCompras">
						</label>
					</div>
					
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios sobre la cuota de mercado</p>
							<textarea class="form-control w-100 d-block form-control--disabled" disabled rows="3" v-model="form.comentariosCuotaMercado"></textarea>
						</label>
					</div>

					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0"><span class="text-danger">*</span> ¿Opera en más de una geografía?</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.multipleGeografia">
						</label>
					</div>

					<div v-if="form.multipleGeografia == 'SI'" class="col-8 p-2">
						<label class="col-6 p-0 m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios sobre las geografías</p>
							<textarea class="form-control w-100 d-block form-control--disabled" disabled rows="3" v-model="form.comentariosMultipleGeografia"></textarea>
						</label>

						<h3>Desglose de ingresos país/Geografía (%)</h3>
						<div class="d-flex" v-if="showGeo.length">
							<div class="py-4 mx-auto col-8" >
								<table class="s-table w-100 text-center">
									<thead>
										<tr>
											<th>NOMBRE</th>
											<th>Porcentaje</th>
											<th>AÑO</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(sh, index) in showGeo" :key="`geos_${index}`">
											<td>{{sh.nombre}}</td>
											<td>{{sh.porcentaje}}%</td>
											<td>{{sh.ano}}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="col-4">
								<apexchart type="donut" :options="chart.chartOptions" :series="chart.series"></apexchart>
							</div>
						</div>
					</div>

					<div class="col-4 p-2">
						<label class="d-block">
							<p class="m-0"><span class="text-danger">*</span> ¿Opera en más de una Actividad Económica?</p>
							<input class="form-control form-control--disabled" disabled type="text" v-model="form.multipleActividadEconomica">
						</label>
					</div>

					<div v-if="form.multipleActividadEconomica == 'SI'" class="col-4 p-2">
						<label class="col-12 p-0 m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios sobre las actividades</p>
							<textarea class="form-control w-100 d-block form-control--disabled" disabled rows="3" v-model="form.comentariosMultipleActividadEconomica"></textarea>
						</label>
					</div>
					<div v-if="form.multipleActividadEconomica == 'SI'" class="py-4 mx-auto col-8" >
						<table class="s-table w-100 text-center">
							<thead>
								<tr>
									<th>NOMBRE</th>
									<th v-for="(ano, index) in getAnosList(showActivities)" :key="`activity_${index}`">
										{{ano}}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(sh, index) in showActivities" :key="`activity-2_${index}`">
									<td>{{sh.nombre}}</td>
									<td v-for="(ano, index) in getAnosList(showActivities)" :key="`activity_${index}`">
										{{ ano == sh.ano ? sh.porcentaje : 0 }}%
									</td>
								</tr>
							</tbody>
						</table>
					</div>


					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Número de productos y servicios</p>
							<input class="form-control form-control--disabled" disabled  type="text" v-model="form.numeroProductosServicios">
						</label>
					</div>
					
					
					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Vulnerabilidad al tipo de cambio</p>
							<input class="form-control form-control--disabled" disabled  type="text" v-model="form.vulnerabilidadTipoCambio">
						</label>
					</div>

					<div class="col-4 p-2"></div>

					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios sobre el número de productos y servicios</p>
							<textarea class="form-control w-100 d-block form-control--disabled" disabled  rows="3" v-model="form.comentariosNumeroProductosServicios"></textarea>
						</label>
					</div>

					<div class="col-4 p-2">
						<label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Comentarios sobre vulnerabilidad al tipo de cambio</p>
							<textarea class="form-control w-100 d-block form-control--disabled" disabled  rows="3" v-model="form.comentariosVulnerabilidadTipoCambio"></textarea>
						</label>
					</div>
				
					<div class="col-4 p-2">
						<!-- <label class="d-block m-0">
							<p class="m-0"><span class="text-danger">*</span> Empresa acreditada, es:</p>
							<input class="form-control form-control--disabled" disabled  type="text" v-model="form.empresaAcreditada">
						</label> -->
					</div>
					
				</div>
			</div>
			<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c_abr_n_4" aria-expanded="true" aria-controls="c_abr_n_4">
				<div class="d-flex">
					<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Clientes y Proveedores</span></h6>
				</div>
			</div>
			<div id="c_abr_n_4" class="collapse hide" aria-labelledby="headingOne">
				<div class="d-flex flex-wrap">

					<div class="col-4 p-2">
						<p class="m-0"><span class="text-danger">*</span>  Concetranción de Clientes</p>
						<input class="form-control form-control--disabled" disabled  type="text" v-model="form.concentracionClientes">
					</div>
					
					<div class="col-4 p-2">
						<p class="m-0"><span class="text-danger">*</span>  Concetranción de Proveedores</p>
						<input class="form-control form-control--disabled" disabled  type="text" v-model="form.concentacionProveedores">
					</div>


					<div class="col-12 p-2" v-if="form.concentracionClientes">
						<div class="col-12 p-0" v-if="showPrincipalesClientes.length">
							<table class="s-table w-100 text-center">
								<thead>
									<tr>
										<th>NOMBRE</th>
										<th>Porcentaje</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(cliente, index) in showPrincipalesClientes" :key="`pricipalesc_${index}`">
										<td>{{cliente.nombre}}</td>
										<td>{{cliente.participacion}}%</td>
									</tr>
								</tbody>
							</table>
						</div>

					</div>	

				</div>
			</div>
			
		</div>
		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<div class="modal s-modal fade" style="font-size: 0.8em" id="formBusinnessriskModal" tabindex="-1" role="dialog" aria-labelledby="formBusinnessriskModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-xl " role="document">
				<div class="modal-content">
				<div class="modal-header p-0">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="s-collapse__header collapsed" data-toggle="collapse" data-target="#c_abr_1" aria-expanded="true" aria-controls="c_abr_1">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span>Información General</span></h6>
						</div>
					</div>
					<div id="c_abr_1" class="collapse hide" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap">
							<div class="col-12 py-3">
								<table class="s-table w-100 mx-auto">
									<thead>
										<tr>
											<th></th>
											<th>2019</th>
											<th>2018</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												Backlog (en miles y TC de lo EEFF)
											</td>
											<td class="text-center">
												0
											</td>
											<td class="text-center">
												0
											</td>
											<td class="text-right">
												<button class="s-btn s-btn--outline p-1">
													<svg-icon name="down" />
												</button>
											</td>
										</tr>
										<tr>
											<td>
												Backlog/Ventas
											</td>
											<td class="text-center">
												0%
											</td>
											<td class="text-center">
												0%
											</td>
											<td class="text-right">
												<button class="s-btn s-btn--outline p-1">
													<svg-icon name="down" />
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="col-3">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Descripción de la cartera</p>
									<input class="form-control" type="text" v-model="form.descripcionCartera">
								</label>
							</div>
						</div>
					</div>

					<div class="s-collapse__header   mt-2" data-toggle="collapse" data-target="#c_abr_2" aria-expanded="true" aria-controls="c_abr_2">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> ACTIVIDAD DEL CLIENTE</span></h6>
						</div>
					</div>
					<div id="c_abr_2" class="collapse show" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap">

							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Descripción de la actividad del cliente</p>
									<textarea class="form-control" type="text" v-model="form.descripcionActividad">
									</textarea>
									<characters-available :max="1000" :text="form.descripcionActividad"></characters-available>
								</label>
							</div>

							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Alcance Geográfico del Cliente</p>
									<select class="form-control" type="text" v-model="form.alcanceGeografico">
										<option disabled valued=""></option>
										<option value="Local">Local</option>
										<option value="Regional">Regional</option>
										<option value="Nacional">Nacional</option>
										<option value="Internacional Global">Internacional Global</option>
										<option value="Internacional Regional">Internacional Regional</option>
									</select>
								</label>
							</div>
							
							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Cuota de Mercado</p>
									<select class="form-control" type="text" v-model="form.cuotaMercado">
										<option disabled valued=""></option>
										<option value="Lider">Lider</option>
										<option value="Alto">Alto</option>
										<option value="Medio">Medio</option>
										<option value="Bajo">Bajo</option>
										<option value="Insignificante">Insignificante</option>
									</select>
								</label>
							</div>
							
							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Nivel de exportaciones sobre el total de sus ventas</p>
									<select class="form-control" type="text" v-model="form.nivelExporacionesVentas">
										<option disabled valued=""></option>
										<option value="0-15%">0-15%</option>
										<option value="15%-30%">15%-30%</option>
										<option value="30%-70%">30%-70%</option>
										<option value="+70%">+70%</option>
										<option value="Sin exportaciones">Sin exportaciones</option>
									</select>
								</label>
							</div>
							
							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Nivel de importaciones sobre el total de sus compras</p>
									<select class="form-control" type="text" v-model="form.nivelImportacionesCompras">
										<option disabled valued=""></option>
										<option value="0-15%">0-15%</option>
										<option value="15%-30%">15%-30%</option>
										<option value="30%-70%">30%-70%</option>
										<option value="+70%">+70%</option>
										<option value="Sin exportaciones">Sin importaciones</option>
									</select>
								</label>
							</div>
							
							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre la cuota de mercado</p>
									<textarea class="form-control w-100 d-block" rows="3" v-model="form.comentariosCuotaMercado"></textarea>
									<characters-available :max="500" :text="form.comentariosCuotaMercado"></characters-available>
								</label>
							</div>

							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> ¿Opera en más de una geografía?</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="abr_omg" value="SI" v-model="form.multipleGeografia">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" >
											<input type="radio" name="abr_omg" value="NO" v-model="form.multipleGeografia">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
							</div>

							<div v-if="form.multipleGeografia == 'SI'" class="col-8 p-2">
								<label class="col-6 p-0 m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre las geografías</p>
									<textarea class="form-control w-100 d-block" rows="3" v-model="form.comentariosMultipleGeografia"></textarea>
									<characters-available :max="1000" :text="form.comentariosMultipleGeografia"></characters-available>

								</label>

								<h3>Desglose de ingresos país/Geografía (%)</h3>
								<div class="d-flex" v-if="showGeo.length">
									<div class="py-4 mx-auto col-8" >
										<table class="s-table w-100 text-center">
											<thead>
												<tr>
													<th>NOMBRE</th>
													<th>Porcentaje</th>
													<th>AÑO</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(sh, index) in showGeo" :key="`geos_${index}`">
													<td>{{sh.nombre}}</td>
													<td>{{sh.porcentaje}}%</td>
													<td>{{sh.ano}}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="col-4">
										<apexchart type="donut" :options="chart.chartOptions" :series="chart.series"></apexchart>
									</div>
								</div>
							</div>

							<div v-if="form.multipleGeografia == 'SI'" class="col-12 p-2">
								<button class="s-btn s-btn--outline s-btn--primary"  @click="showGeografias()">Administrar Geografías</button>
							</div>
							
							<div class="col-4 p-2">
								<label class="d-block">
									<p class="m-0"><span class="text-danger">*</span> ¿Opera en más de una Actividad Económica?</p>
									<div class="s-tf">
										<label class="s-tf__item">
											<input type="radio" name="abr_omae" value="SI" v-model="form.multipleActividadEconomica">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item">
											<input type="radio" name="abr_omae" value="NO" v-model="form.multipleActividadEconomica">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</label>
							</div>

							<div v-if="form.multipleActividadEconomica == 'SI'" class="col-4 p-2">
								<label class="col-12 p-0 m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre las actividades</p>
									<textarea class="form-control w-100 d-block" rows="3" v-model="form.comentariosMultipleActividadEconomica"></textarea>
									<characters-available :max="500" :text="form.comentariosMultipleActividadEconomica"></characters-available>
									
								</label>
							</div>
							<div v-if="form.multipleActividadEconomica == 'SI'" class="py-4 mx-auto col-8" >
								<table class="s-table w-100 text-center">
									<thead>
										<tr>
											<th>NOMBRE</th>
											<th v-for="(ano, index) in getAnosList(showActivities)" :key="`activity_${index}`">
												{{ano}}
											</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(sh, index) in showActivities" :key="`activity-2_${index}`">
											<td>{{sh.nombre}}</td>
											<td v-for="(ano, index) in getAnosList(showActivities)" :key="`activity_${index}`">
												{{ ano == sh.ano ? sh.porcentaje : 0 }}%
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div v-if="form.multipleActividadEconomica == 'SI'" class="col-12 p-2">
								<button class="s-btn s-btn--outline s-btn--primary"  @click="showActividades">Administrar Actividades</button>
							</div>

							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Número de productos y servicios</p>
									<select class="form-control" type="text" v-model="form.numeroProductosServicios">
										<option value=""></option>
										<option value="Un solo producto">Un solo producto</option>
										<option value="Baja diversificación">Baja diversificación</option>
										<option value="Alta diversificación">Alta diversificación</option>
										<option value="Desconocido">Desconocido</option>
									</select>
								</label>
							</div>
							
							
							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Vulnerabilidad al tipo de cambio</p>
									<input class="form-control" type="text" v-model="form.vulnerabilidadTipoCambio">
								</label>
							</div>

							<div class="col-4 p-2"></div>

							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre el número de productos y servicios</p>
									<textarea class="form-control w-100 d-block" rows="3" v-model="form.comentariosNumeroProductosServicios"></textarea>
									<characters-available :max="500" :text="form.comentariosNumeroProductosServicios"></characters-available>

								</label>
							</div>

							<div class="col-4 p-2">
								<label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Comentarios sobre vulnerabilidad al tipo de cambio</p>
									<textarea class="form-control w-100 d-block" rows="3" v-model="form.comentariosVulnerabilidadTipoCambio"></textarea>
									<characters-available :max="500" :text="form.comentariosVulnerabilidadTipoCambio"></characters-available>
								</label>
							</div>
						
							<div class="col-4 p-2">
								<!-- <label class="d-block m-0">
									<p class="m-0"><span class="text-danger">*</span> Empresa acreditada, es:</p>
									<input class="form-control" type="text" v-model="form.empresaAcreditada">
								</label> -->
							</div>
							
						</div>
					</div>
					<div class="s-collapse__header collapsed  mt-2" data-toggle="collapse" data-target="#c_abr_4" aria-expanded="true" aria-controls="c_abr_4">
						<div class="d-flex">
							<h6 class="title font-weight-normal"><svg-icon name="chevrondown" /> <span> Clientes y Proveedores</span></h6>
						</div>
					</div>
					<div id="c_abr_4" class="collapse hide" aria-labelledby="headingOne">
						<div class="d-flex flex-wrap">

							<div class="col-4 p-2">
								<p class="m-0"><span class="text-danger">*</span>  Concentración de Clientes</p>
								<select class="form-control d-block"   v-model="form.concentracionClientes">'
										<option value="" disabled></option>
										<option value="Alta: Uno o dos clientes con lata concentración de las ventas / Irremplazables">Alta: Uno o dos clientes con lata concentración de las ventas / Irremplazables</option>
										<option value="Media: Poco clientes concentran la mayor parte de las ventas / Dificultad de sustitución">Media: Poco clientes concentran la mayor parte de las ventas / Dificultad de sustitución</option>
										<option value="Baja: Mucho clientes y baja concentración de las ventas / Facilidad de sustitución">Baja: Mucho clientes y baja concentración de las ventas / Facilidad de sustitución</option>
								</select>
							</div>
							
							<div class="col-4 p-2">
								<p class="m-0"><span class="text-danger">*</span>  Concentración de Proveedores</p>
								<select class="form-control d-block"   v-model="form.concentacionProveedores">'
										<option value="" disabled></option>
										<option value="Alta: Uno o dos proveedores surten los principales insumos de la empresa / Irremplazables">Alta: Uno o dos proveedores surten los principales insumos de la empresa / Irremplazables</option>
										<option value="Media: Pocos Proveedores surten los pricipales insumos de la empresa / Dificultad de sustitución">Media: Pocos Proveedores surten los pricipales insumos de la empresa / Dificultad de sustitución</option>
										<option value="Baja: Muchos Proveedores surten los principales insumos de la empresa / Fácil sustitución">Baja: Muchos Proveedores surten los principales insumos de la empresa / Fácil sustitución</option>
								</select>
							</div>


							<div class="col-12 p-2" v-if="form.concentracionClientes">
								<div class="col-12 p-0" v-if="showPrincipalesClientes.length">
									<table class="s-table w-100 text-center">
										<thead>
											<tr>
												<th>NOMBRE</th>
												<th>Porcentaje</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(cliente, index) in showPrincipalesClientes" :key="`pricipalesc_${index}`">
												<td>{{cliente.nombre}}</td>
												<td>{{cliente.participacion}}%</td>
											</tr>
										</tbody>
									</table>
								</div>

								<!-- <div  class="col-12 p-2">
									<button class="s-btn s-btn--outline s-btn--primary"  @click="showClientes">Administrar Principales clientes</button>
								</div> -->

							</div>	

						</div>
					</div>
					
				</div>
				<div class="modal-footer">
					<button type="button" class="s-btn s-btn--outline" data-dismiss="modal">Cancelar</button>
					<button type="button" class="s-btn s-btn--primary" data-dismiss="modal" @click="save">Guardar</button>
				</div>
				</div>
			</div>
		</div>

		<div class="modal s-modal fade" id="geografiasModal" tabindex="-1" role="dialog" aria-labelledby="geografiasModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title w-100 text-center" id="geografiasModalLabel">Administrar Geografías</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="d-flex" v-for="(geo, index) in geografiasForm" :key="`geo_${index}`">
						<div class="col-4 mt-auto">
							<div class="position-relative">
								<div class="position-relative">
									<div class="s-input" data-v-step="cs1">
										<input v-if="!geo.nombre" class="form-control w-100" type="text" v-model="geo.query">
										<input v-else class="form-control w-100" disabled type="text" v-model="geo.nombre">
										<svg-icon class="mx-2" name="search" />
										<span class="m-0" @click="geo.nombre = ''" v-if="geo.nombre">
											<svg-icon class="mx-2 s-input__delete" name="close" />
										</span>
									</div>
									
								</div>
								<div v-if="geo.query" class="s-query-result">
									<div class="d-flex" @click="geo.nombre = geo.query, geo.query = ''">
										<button class="s-query-btn my-auto">
											<svg-icon name="add" />
										</button>
										<div class="ml-2 my-auto">
											<p class="small m-0">Create new arce...</p>
											<p class="m-0 small">{{geo.query}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-4 mt-auto">
							<p class="m-0"> 
								Año
							</p>
							<input class="form-control w-100" type="text" v-model="geo.ano">
						</div>
						
						<div class="col-3 mt-auto">
							<p class="m-0"> 
								Porcentaje
							</p>
							<input class="form-control w-100" type="text" v-model="geo.porcentaje">
						</div>
						<div class="col-1 mt-auto">
							<button v-if="geografiasForm.length > 1" @click="deleteItem(index, geografiasForm)" class="s-btn s-btn--transparent px-0">
								<svg-icon name="delete" />
							</button>
						</div>
					</div>
					<div class="text-right mt-2">
						<button @click="addNew" class="s-query-btn my-auto mr-2 mt-2">
							<svg-icon name="add" />
						</button>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" @click="saveAllGoe" class="s-btn s-btn--primary">Save all</button>
				</div>
				</div>
			</div>
		</div>
		<div class="modal s-modal fade" id="actividadesModal" tabindex="-1" role="dialog" aria-labelledby="actividadesModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title w-100 text-center" id="actividadesModalLabel">Administrar Actividades</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="d-flex" v-for="(actividad, index) in actividadesForm" :key="`actividad_${index}`">
						<div class="col-4 mt-auto">
							<div class="position-relative">
								<div class="position-relative">
									<div class="s-input" data-v-step="cs1">
										<input v-if="!actividad.nombre" class="form-control w-100" type="text" v-model="actividad.query">
										<input v-else class="form-control w-100" disabled type="text" v-model="actividad.nombre">
										<svg-icon class="mx-2" name="search" />
										<span class="m-0" @click="actividad.nombre = ''" v-if="actividad.nombre">
											<svg-icon class="mx-2 s-input__delete" name="close" />
										</span>
									</div>
									
								</div>
								<div v-if="actividad.query" class="s-query-result">
									<div class="d-flex" @click="actividad.nombre = actividad.query, actividad.query = ''">
										<button class="s-query-btn my-auto">
											<svg-icon name="add" />
										</button>
										<div class="ml-2 my-auto">
											<p class="small m-0">Create new arce...</p>
											<p class="m-0 small">{{actividad.query}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-4 mt-auto">
							<p class="m-0"> 
								Año
							</p>
							<input class="form-control w-100" type="text" v-model="actividad.ano">
						</div>
						
						<div class="col-3 mt-auto">
							<p class="m-0"> 
								Porcentaje
							</p>
							<input class="form-control w-100" type="text" v-model="actividad.porcentaje">
						</div>
						<div class="col-1 mt-auto">
							<button v-if="actividadesForm.length > 1" @click="deleteItem(index, actividadesForm)" class="s-btn s-btn--transparent px-0">
								<svg-icon name="delete" />
							</button>
						</div>
					</div>
					<div class="text-right mt-2">
						<button @click="addNewActivity" class="s-query-btn my-auto mr-2 mt-2">
							<svg-icon name="add" />
						</button>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" @click="saveAllActivities" class="s-btn s-btn--primary">Save all</button>
				</div>
				</div>
			</div>
		</div>

		<!-- ============================================ -->
		<!-- ============================================ -->
		<!-- ============================================ -->
		<div class="modal s-modal fade" id="clientesModal" tabindex="-1" role="dialog" aria-labelledby="clientesModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title w-100 text-center" id="clientesModalLabel">Administrar Principales clientes</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="d-flex" v-for="(cliente, index) in principalesClientesForm" :key="`pcliente_${index}`">
						<div class="col-6 mt-auto">
							<p class="m-0"> 
								Nombre
							</p>
							<div class="position-relative">
								<div class="position-relative">
									<div class="s-input" data-v-step="cs1">
										<input v-if="!cliente.nombre" class="form-control w-100" type="text" v-model="cliente.query">
										<input v-else class="form-control w-100" disabled type="text" v-model="cliente.nombre">
										<svg-icon class="mx-2" name="search" />
										<span class="m-0" @click="cliente.nombre = ''" v-if="cliente.nombre">
											<svg-icon class="mx-2 s-input__delete" name="close" />
										</span>
									</div>
									
								</div>
								<div v-if="cliente.query" class="s-query-result">
									<div class="d-flex" @click="cliente.nombre = cliente.query, cliente.query = ''">
										<button class="s-query-btn my-auto">
											<svg-icon name="add" />
										</button>
										<div class="ml-2 my-auto">
											<p class="small m-0">Create new arce...</p>
											<p class="m-0 small">{{cliente.query}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-5 mt-auto">
							<p class="m-0"> 
								Participación
							</p>
							<input class="form-control w-100" type="text" v-model="cliente.participacion">
						</div>
						<div class="col-1 mt-auto">
							<button v-if="principalesClientesForm.length > 1" @click="deleteItem(index, principalesClientesForm)" class="s-btn s-btn--transparent px-0">
								<svg-icon name="delete" />
							</button>
						</div>
					</div>
					<div class="text-right mt-2">
						<button @click="addNewClient" class="s-query-btn my-auto mr-2 mt-2">
							<svg-icon name="add" />
						</button>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" @click="saveAllClientes" class="s-btn s-btn--primary">Save all</button>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>
